(function ($, window) {
    let product_logo_management = {
        toggle_checkbox_selector: '.toggle-form-js',
        logo_value_element: '.prodigy-logo-values-js',
        template_selector: '#logo-form-template',
        main_logo_management_container: '.logo-container-js',
        block_logo_management_container: '.container-js',
        max_logo_quantity: 3,
        logo_options_ids: [],
        // logo can be just for 'color' attribute
        logo_attribute: 'color',
        prodigy_product_swatch_block_element: '.prodigy-product__swatch-block-js',

        init: function () {
            this.set_default_logo();
            this.show_logo_form();
            if (this.is_logo_swatches()) {
                this.set_logos_swatches();
                this.change_logo_radio();
            } else {
                this.set_logos();
            }

            this.set_custom_location_select();
            this.set_custom_logo_select();

            if (!prodigyProduct.is_variants() && !this.is_logo_swatches()) {
                this.set_logo_dropdown_for_single_product();
            }

            this.update_forms_visibility();

            this.open_tooltip_mobile();
            this.close_tooltip_mobile();
        },

        is_logo: function () {
            return $('.prodigy-logo-tool__container.opened').length > 0;
        },

        set_default_logo: function () {
            let self = this;
            let logo_images_options = self.get_images_logos_settings();

            if (typeof logo_images_options !== 'undefined') {
                if (logo_images_options && logo_images_options.length && logo_images_options.length === 0) {
                    return;
                }

                if (Object.entries(logo_images_options).length > 0) {
                    let suitable_logo_image = Object.entries(logo_images_options)[0][1];
                    for (let i in logo_images_options) {
                        if (logo_images_options[i].is_default) {
                            suitable_logo_image = logo_images_options[i];
                            break;
                        }
                    }

                    let $container = $('.prodigy-logo-tool__container.opened');
                    if (self.is_logo_swatches()) {
                        self.set_swatch_logo_value($container.find('.prodigy-product__logo-swatch-js'), suitable_logo_image.logo_id);
                    } else {
                        self.set_logo_select_value($container.find('.prodigy-logo-values-js'), suitable_logo_image.logo_id);
                    }
                    let $location_select = $container.find('.prodigy-logo-location-js');
                    let preselected_location_ids = self.get_selected_locations_list($location_select);
                    if (self.is_available_logo_location(suitable_logo_image.logo_id, suitable_logo_image.location_id, preselected_location_ids, logo_images_options)) {
                        self.refresh_locations_list($location_select, logo_images_options, preselected_location_ids, suitable_logo_image.logo_id)
                        self.set_location_select_value($location_select, suitable_logo_image.location_id);
                    } else {
                        self.preselect_logo_location($container, logo_images_options, suitable_logo_image.logo_id);
                    }

                    self.update_locations_availability();
                    self.update_main_gallery_images(suitable_logo_image.logo_id, suitable_logo_image.location_id);
                }
            }
        },

        set_logo_dropdown_for_single_product: function () {
            this.set_logos();
            this.get_logos_price();
        },

        is_logo_swatches: function () {
            return $('.prodigy-product__logo-swatch-js').length > 0;
        },

        update_main_gallery_images: function (logo_id, location_id) {
            let self = this;
            const options = self.get_images_logos_settings();
            const $current_image = $('#gallery-main .swiper-slide-active .main-gallery-image-js');
            let is_image_available = false;
            for (let i in options) {
                if (parseInt(options[i].logo_id) === parseInt(logo_id)
                    && parseInt(options[i].location_id) === parseInt(location_id)
                    && parseInt(options[i].image_id) === $current_image.data('image-id')
                ) {
                    is_image_available = true;
                    break;
                }
            }

            if (!is_image_available) {
                let image_id;
                for (let i in options) {
                    if (parseInt(options[i].logo_id) === parseInt(logo_id)
                        && parseInt(options[i].location_id) === parseInt(location_id)
                    ) {
                        image_id = options[i].image_id;
                    }
                }

                for (let j in prodigyProduct.swiperMain.slides) {
                    const slide_image_id = $(prodigyProduct.swiperMain.slides[j]).find('.main-gallery-image-js').data('image-id');
                    if (parseInt(slide_image_id) === parseInt(image_id)) {
                        prodigyProduct.swiperMain.slideTo(j);
                    }
                }
            }
        },

        update_forms_visibility: function () {
            let self = this;
            const max_form_number = self.get_max_add_logo_forms();
            let close_forms_number = $('.prodigy-logo-tool__container.opened').length - max_form_number;

            if (close_forms_number < 0 && $('.prodigy-logo-tool__container.closed').length === 0) {
                let $clone = $(self.template_selector).contents().clone();
                $(self.main_logo_management_container).append($clone);
                this.set_custom_logo_select();
            }

            //TODO - this code removing swatch logos form
            if (close_forms_number > 0 && !prodigyProductBulk.is_active_logo_bulk) {
                for (let i = 1; i <= close_forms_number; i++) {
                    let last_form = $('.prodigy-logo-tool__container.opened:last');
                    last_form.remove();
                }
            }

            if ($('.prodigy-logo-tool__container').length === 1 && max_form_number > 0) {
                $('.prodigy-logo-tool__container').removeClass('closed');
                $('.prodigy-logo-tool__container').addClass('opened');
            }

            if ($('.prodigy-logo-tool__container.opened').length === max_form_number) {
                $('.prodigy-logo-tool__container.closed').remove();
            }

            $('.prodigy-logo-tool__container.opened:first').find('.prodigy-logo-tool__toggler-block').remove();
        },

        get_locations_set: function (images_logos_settings, logo_id) {
            let location_set = new Set();
            for (let i in images_logos_settings) {
                if (logo_id === undefined || parseInt(images_logos_settings[i].logo_id) === parseInt(logo_id)) {
                    let location_id = images_logos_settings[i].location_id;
                    if (!location_set.has(location_id)) {
                        location_set.add(location_id)
                    }
                }
            }
            return location_set;
        },

        find_suitable_logo_location: function (images_logos_settings, default_logo_id, excluded_location_ids) {
            for (let i in images_logos_settings) {
                let is_location_available = !excluded_location_ids.includes(parseInt(images_logos_settings[i].location_id));
                let is_same_logo = false;
                if (typeof default_logo_id === 'undefined' || parseInt(images_logos_settings[i].logo_id) === parseInt(default_logo_id)) {
                    is_same_logo = true;
                }
                if (is_same_logo && is_location_available) {
                    return images_logos_settings[i];
                }
            }

            for (let i in images_logos_settings) {
                let is_location_available = !excluded_location_ids.includes(parseInt(images_logos_settings[i].location_id));
                if (is_location_available) {
                    return images_logos_settings[i];
                }
            }

            return null;
        },

        update_locations_availability: function (attribute_name) {
            let self = this;
            let image_logos_settings = self.get_images_logos_settings(attribute_name);

            $('.prodigy-logo-tool__container.opened').each(function () {
                let $container = $(this);
                let $location_select = $container.find('.prodigy-logo-location-js');
                let logo_id = self.is_logo_swatches() ? $container.find('.prodigy-product__logo-swatch-js:checked').val() : $container.find('.prodigy-logo-values-js').val();
                let preselected_location_ids = self.get_selected_locations_list($location_select);
                let location_set = self.get_locations_set(image_logos_settings, logo_id);
                $location_select.find('option').attr('disabled', true);
                for (const location_id of location_set) {
                    if (!preselected_location_ids.includes(location_id)) {
                        $location_select.find('option[value="' + location_id + '"]').attr('disabled', false);
                    }
                }
                self.disable_logos_with_no_locations($container, image_logos_settings);
            });
        },

        is_available_logo_location: function (logo_id, location_id, preselected_logo_location, image_logos_settings) {
            if (preselected_logo_location.includes(location_id)) {
                return false;
            }
            for (let i in image_logos_settings) {
                if (parseInt(image_logos_settings[i].logo_id) === parseInt(logo_id) && parseInt(image_logos_settings[i].location_id) === parseInt(location_id)) {
                    return true;
                }
            }

            return false;
        },

        refresh_locations_list: function ($location_select, image_logos_settings, preselected_location_ids, logo_id) {
            let self = this;
            let location_set = self.get_locations_set(image_logos_settings, logo_id);
            for (const location_id of location_set) {
                if (!preselected_location_ids.includes(location_id)) {
                    $location_select.find('option[value="' + location_id + '"]').prop('disabled', false);
                }
            }
        },

        preselect_logo_location: function ($container, image_logos_settings, logo_id) {
            let self = this;

            let $location_select = $container.find('.prodigy-logo-location-js');
            let preselected_location_ids = self.get_selected_locations_list($location_select);
            let suitable_logo_location = self.find_suitable_logo_location(image_logos_settings, logo_id, preselected_location_ids);
            if (self.is_available_logo_location(logo_id, $location_select.val(), preselected_location_ids, image_logos_settings)) {
                return;
            }

            if (suitable_logo_location !== null) {
                self.refresh_locations_list($location_select, image_logos_settings, preselected_location_ids, logo_id);
                self.set_location_select_value($location_select, suitable_logo_location.location_id);
                if (parseInt(suitable_logo_location.logo_id) !== parseInt(logo_id)) {
                    this.is_logo_swatches() ? self.set_swatch_logo_value($container.find('.prodigy-product__logo-swatch-js'), suitable_logo_location.logo_id) : self.set_logo_select_value($container.find('.prodigy-logo-values-js'), suitable_logo_location.logo_id);
                }
            }

            self.disable_logos_with_no_locations($container, image_logos_settings);
        },

        disable_logos_with_no_locations: function ($container, image_logos_settings) {
            let self = this;
            if (self.is_logo_swatches()) {
                self.disable_logos_swatches_with_no_locations($container, image_logos_settings);
                return;
            }

            $('.prodigy-logo-tool__container').each(function () {
                let $container = $(this);
                let $location_select = $container.find('.prodigy-logo-location-js');
                let preselected_location_ids = self.get_selected_locations_list($location_select);

                $container.find('.prodigy-logo-values-js option').each(function () {
                    let is_empty_locations = true;
                    for (let i in image_logos_settings) {
                        if (parseInt(image_logos_settings[i].logo_id) === parseInt($(this).attr('value')) && !preselected_location_ids.includes(parseInt(image_logos_settings[i].location_id))) {
                            is_empty_locations = false;
                            break;
                        }
                    }

                    $(this).prop('disabled', is_empty_locations);
                });
            });
        },

        disable_logos_swatches_with_no_locations: function ($container, image_logos_settings) {
            let self = this;

            $('.prodigy-logo-tool__container').each(function () {
                let $container = $(this);
                let $location_select = $container.find('.prodigy-logo-location-js');
                let preselected_location_ids = self.get_selected_locations_list($location_select);

                $container.find('.prodigy-product__logo-swatch-js').each(function () {
                    let is_empty_locations = true;
                    for (let i in image_logos_settings) {
                        if (parseInt(image_logos_settings[i].logo_id) === parseInt($(this).val()) && !preselected_location_ids.includes(parseInt(image_logos_settings[i].location_id))) {
                            is_empty_locations = false;
                            break;
                        }
                    }

                    $(this).prop('disabled', is_empty_locations);

                    if (is_empty_locations) {
                        $(this).closest('.prodigy-tooltip-js').addClass('prodigy-logo__disabled');
                        $(this).closest('.prodigy-radio__swatch-logo-btn').find('.prodigy-product__swatch-init-js').addClass('prodigy-logo__disabled-mobile');
                    } else {
                        $(this).closest('.prodigy-tooltip-js').removeClass('prodigy-logo__disabled');
                        $(this).closest('.prodigy-radio__swatch-logo-btn').find('.prodigy-product__swatch-init-js').removeClass('prodigy-logo__disabled-mobile');
                    }
                });
            });
        },

        open_tooltip_mobile: function () {
            $(document).on('click', '.prodigy-logo__disabled-mobile', function (e) {
                e.preventDefault();
                let $tooltip = $(this).closest('.prodigy-tooltip-js').find('.prodigy-tooltip__message');
                let $backdrop = $(this).closest('.prodigy-tooltip-js').find('.prodigy-after__backdrop');

                $tooltip.addClass('d-flex');
                $backdrop.show();
            });
        },

        close_tooltip_mobile: function () {
            $(document).on('click', '.prodigy-after__backdrop', function () {
                let $tooltip = $(this).closest('.prodigy-tooltip-js').find('.prodigy-tooltip__message');

                $tooltip.removeClass('d-flex');
                $(this).hide();
            });
        },

        set_location_select_value($location_select, value) {
            let self = this;
            $location_select.val(value);
            if (typeof $location_select !== undefined && $location_select.get(0) && typeof $location_select.get(0).msDropdown !== "undefined") {
                $location_select.get(0).msDropdown.refresh();
            } else {
                self.set_custom_location_select();
            }
        },

        set_swatch_logo_value($logo_radio, value) {
            $logo_radio.filter('[value="' + value + '"]').prop('checked', 'checked');
        },

        set_logo_select_value($logo_select, value) {
            let self = this;
            $logo_select.val(value);
            if (typeof $logo_select !== undefined && $logo_select.get(0) && typeof $logo_select.get(0).msDropdown !== "undefined") {
                $logo_select.get(0).msDropdown.refresh();
            } else {
                self.set_custom_logo_select();
            }
        },


        disable_selected_location: function (location_id) {
            $('.prodigy-logo-location-js').each(function () {
                if (parseInt($(this).val()) !== parseInt(location_id)) {
                    $(this).find('option[value="' + location_id + '"]').attr('disabled', true);
                }
                if (typeof $(this).get(0).msDropdown !== "undefined") {
                    $(this).get(0).msDropdown.refresh();
                }
            });
        },

        enable_selected_location: function (location_id) {
            $('.prodigy-logo-location-js').each(function () {
                if (parseInt($(this).val()) !== parseInt(location_id)) {
                    $(this).find('option[value="' + location_id + '"]').attr('disabled', false);
                }
                if (typeof $(this).get(0).msDropdown !== "undefined") {
                    $(this).get(0).msDropdown.refresh();
                }
            });
        },

        init_logos_locations_form: function () {
            let self = this;
            const images_logos_settings = self.get_images_logos_settings();

            $('.prodigy-logo-tool__container').each(function () {
                let logo_value;
                if (self.is_logo_swatches()) {
                    let $logo_radio = $(this).find('.prodigy-product__logo-swatch-js');
                    logo_value = $logo_radio.filter(':checked').val();
                } else {
                    let $logo_select = $(this).find('.prodigy-logo-values-js');
                    logo_value = $logo_select.val();
                }
                self.preselect_logo_location($(this), images_logos_settings, logo_value);
            });
        },

        change_logo_radio: function () {
            let self = this;
            $(document).on('click', '.prodigy-product__logo-swatch-js', function () {
                if (self.is_logo_swatches()) {
                    let $container = $(this).closest('.prodigy-logo-tool__form-container');
                    let logo_id = $container.find('.prodigy-product__logo-swatch-js:checked').val();
                    self.preselect_logo_location($container, self.get_images_logos_settings(), logo_id);
                    self.set_logos_swatches();
                    self.update_locations_availability();
                }
                if (prodigyProduct.is_variants()) {
                    prodigyProduct.set_variants_data(self.get_variant_data());
                } else {
                    prodigyProduct.show_master_variant_info();
                }

                if (prodigyProductBulk.is_active_logo_bulk) {
                    $(document).trigger('enable-multiple-quantity');
                }
            });
        },

        set_custom_logo_select: function () {
            let self = this;
            let dropdownOpened = false;
            MsDropdown.make('.prodigy-logo-values-js:not(.inited)', {
                enableAutoFilter: false,
                on: {
                    open: function () {
                        dropdownOpened = true;
                    },
                    change: function (data) {
                        if (dropdownOpened) {
                            let location_select = $(data.option).closest('.prodigy-logo-tool__container').find('.prodigy-logo-location-js');
                            self.preselect_logo_location($(data.option).closest('.prodigy-logo-tool__container'), self.get_images_logos_settings(), data.data.value);
                            self.update_main_gallery_images(data.data.value, location_select.val());
                            self.set_logos();
                            self.get_logos_price();
                            self.update_locations_availability();
                            dropdownOpened = false;

                            if (prodigyProductBulk.is_active_logo_bulk) {
                                $(document).trigger('enable-multiple-quantity');
                            }
                        }
                    },
                    close: function () {
                        if (prodigyProduct.is_variants()) {
                            prodigyProduct.set_variants_data(self.get_variant_data());
                        } else {
                            prodigyProduct.show_master_variant_info();
                        }
                    }
                }
            });
            $('.prodigy-logo-values-js:not(.inited)').addClass('inited');
        },

        set_custom_location_select: function () {
            let self = this;
            let dropdownOpened = false;
            MsDropdown.make('.prodigy-logo-location-js:not(.inited)', {
                enableAutoFilter: false,
                on: {
                    enableAutoFilter: false,
                    open: function () {
                        dropdownOpened = true;
                    },
                    change: function (data) {
                        if (prodigyProductBulk.is_active_logo_bulk) {
                            $(document).trigger('enable-multiple-quantity');
                        } else {
                            if (dropdownOpened) {
                                let $container = $(data.option).closest('.prodigy-logo-tool__container');
                                let location_id = data.data.value;
                                let logo_id;
                                if (self.is_logo_swatches()) {
                                    let logo_radio = $container.find('.prodigy-product__logo-swatch-js');
                                    self.set_logos_swatches();
                                    logo_id = logo_radio.val();
                                } else {
                                    let logo_select = $container.find('.prodigy-logo-values-js');
                                    self.set_logos();
                                    logo_id = logo_select.val();
                                }

                                self.update_locations_availability();
                                self.update_main_gallery_images(logo_id, location_id);
                                if (prodigyProduct.is_variants()) {
                                    prodigyProduct.set_variants_data(self.get_variant_data());
                                } else {
                                    prodigyProduct.show_master_variant_info();
                                }
                            }
                            dropdownOpened = false;
                        }
                    }
                }
            });
            $('.prodigy-logo-location-js:not(.inited)').addClass('inited');
        },

        get_variant_data: function () {
            return $('#variant-data-js').data('variant');
        },

        clear_logos: function () {
            $('svg .prodigy-product__gallery-logo-js').remove();
            $('svg .thumb-gallery-logo-js').remove();
        },

        get_logo_id: function () {
            let logo_id;
            let $container = $('.prodigy-logo-tool__container.opened');
            if (product_logo_management_object.is_logo_swatches()) {
                logo_id = $('.prodigy-product__logo-swatch-js:checked').val();
            } else {
                logo_id = $container.find('.prodigy-logo-values-js').val();
            }

            return logo_id;
        },

        get_images_logos_settings: function (attribute_name = null) {
            let options = [];

            if (prodigyProductBulk.is_active_logo_bulk && attribute_name === null) {
                attribute_name = $('.bulk-container-js:visible').data('attribute');
            }

            if (!prodigyProduct.is_variants() || (prodigyProductBulk.is_active_logo_bulk && attribute_name === this.logo_attribute)) {
                const master_logos = $('#master-logo-locations-data-js');
                options = master_logos.data('locations');
            } else if (prodigyProduct.is_swatches()) {
                let selected_swatch = $('.has-logo-settings-js:checked');
                options = selected_swatch.data('logos');
            } else {
                const $select_for_images = $('option[data-logos]').parent('select');
                if ($select_for_images.val() === '') {
                    return [];
                }
                options = $select_for_images.find('option[value="' + $select_for_images.val() + '"]').data('logos');
            }

            return options;
        },

        get_logos_price: function () {
            let total_price = 0;

            if (this.is_logo_swatches()) {
                $('.prodigy-logo-tool__container.opened .prodigy-product__logo-swatch-js:checked').each(function () {
                    total_price += parseFloat($(this).data('price'));
                });
            } else {
                $('.prodigy-logo-tool__container.opened .prodigy-logo-values-js').each(function () {
                    const $current_option = $(this).find('option[value=' + $(this).val() + ']');
                    total_price += parseFloat($current_option.data('price'));
                });
            }

            return parseFloat(total_price);
        },

        set_logos_swatches: function () {
            let self = this;
            self.clear_logos();
            const images_logos_settings = self.get_images_logos_settings();
            $('.prodigy-logo-tool__container.opened').each(function () {
                const $logo_radio = $(this).find('.prodigy-product__logo-swatch-js:checked');
                const default_logo_name = $logo_radio.data('name');
                const $location_select = $(this).find('.prodigy-logo-location-js');
                const logo_id = $logo_radio.val();
                const location_id = $location_select.val();
                $(this).closest('.prodigy-logo-tool__container').find('.swatch-logo-name-js').text(default_logo_name);
                for (let i in images_logos_settings) {
                    let image_id = images_logos_settings[i].image_id;
                    let $current_image = $('.main-gallery-image-js[data-image-id="' + image_id + '"]');
                    let $current_thumb = $('.thumb-gallery-image-js[data-image-id="' + image_id + '"]');
                    if (parseInt(images_logos_settings[i].logo_id) === parseInt(logo_id) &&
                        parseInt(images_logos_settings[i].location_id) === parseInt(location_id)
                    ) {
                        $current_image.parent('svg').append(self.create_logo_element(images_logos_settings[i]));
                        $current_thumb.closest('svg').append(self.create_logo_element(images_logos_settings[i]));
                    }
                }
                self.update_locations_availability();
            });
        },

        set_logos: function () {
            let self = this;
            self.clear_logos();
            const images_logos_settings = self.get_images_logos_settings();
            $('.prodigy-logo-tool__container.opened').each(function () {
                const $logo_select = $(this).find('.prodigy-logo-values-js');
                const $location_select = $(this).find('.prodigy-logo-location-js');
                const logo_id = $logo_select.val();
                const location_id = $location_select.val();

                for (let i in images_logos_settings) {
                    let image_id = images_logos_settings[i].image_id;
                    let $current_image = $('.main-gallery-image-js[data-image-id="' + image_id + '"]');
                    let $current_thumb = $('.thumb-gallery-image-js[data-image-id="' + image_id + '"]');
                    if (
                        parseInt(images_logos_settings[i].logo_id) === parseInt(logo_id) &&
                        parseInt(images_logos_settings[i].location_id) === parseInt(location_id)
                    ) {
                        $current_image.parent('svg').append(self.create_logo_element(images_logos_settings[i]));
                        $current_thumb.closest('svg').append(self.create_logo_element(images_logos_settings[i]));
                    }
                }
            });
        },

        get_logo_options_for_bulk: function (variants) {
            let self = this;
            let product_options = JSON.parse($('#product-options-data-js').val());
            let active_bulk_attribute = $('.bulk-container-js:visible').data('attribute');
            if (prodigyProduct.is_variants() && prodigyProduct.is_bulk_opened() && active_bulk_attribute === self.logo_attribute) {
                let current_options = self.filter_actual_options(prodigyProduct.get_bulk_options(self.logo_attribute), variants);
                $('.prodigy-logo-tool__container.opened').each(function () {
                    let $container = $(this);
                    let location_id = $container.find('.prodigy-logo-location-js').find('option:selected').val();
                    let current_logo_id = self.is_logo_swatches() ? $container.find('.prodigy-product__logo-swatch-js:checked').val() : $container.find('.prodigy-logo-values-js').val();
                    for (let index in current_options) {
                        if (typeof variants[index]['logo_options_ids'] === "undefined") {
                            variants[index]['logo_options_ids'] = [];
                        }
                        for (let key in product_options[self.logo_attribute]) {
                            if (current_options[index].name !== key || typeof product_options[self.logo_attribute][key]['logos'] === "undefined") {
                                continue;
                            }
                            for (let i in product_options[self.logo_attribute][key]['logos']) {
                                if (
                                    parseInt(product_options[self.logo_attribute][key]['logos'][i]['option_id']) === parseInt(current_options[index].id) &&
                                    parseInt(product_options[self.logo_attribute][key]['logos'][i]['location_id']) === parseInt(location_id) &&
                                    parseInt(product_options[self.logo_attribute][key]['logos'][i]['logo_id']) === parseInt(current_logo_id)
                                ) {
                                    variants[index]['logo_options_ids'].push(parseInt(i));
                                    delete product_options[self.logo_attribute][key]['logos'][i];
                                }
                            }
                        }
                    }
                });
            } else if (prodigyProductBulk.is_active_logo_bulk || (active_bulk_attribute !== self.logo_attribute)) {
                if (typeof variants['logo_options_ids'] === "undefined" || variants['logo_options_ids'].length > 0) {
                    variants['logo_options_ids'] = [];
                }
                $('.prodigy-logo-tool__container.opened').each(function () {
                    const logo_id = self.is_logo_swatches() ? $(this).find('.prodigy-product__logo-swatch-js:checked').val() : $(this).find('.prodigy-logo-values-js').val();
                    const location_id = $(this).find('.prodigy-logo-location-js').val();
                    if (typeof variants.length === "undefined") {
                        const images_logos_settings = self.get_images_logos_settings();
                        for (let i in images_logos_settings) {
                            if (typeof variants['logo_options_ids'] === "undefined") {
                                variants['logo_options_ids'] = [];
                            }
                            if (
                                parseInt(images_logos_settings[i].logo_id) === parseInt(logo_id) &&
                                parseInt(images_logos_settings[i].location_id) === parseInt(location_id)
                            ) {
                                variants['logo_options_ids'].push(parseInt(i));
                                break;
                            }
                        }
                    } else {
                        let color_option_slug = $('.attribute_values_js[data-slug="color"] option:selected').data('slug');

                        if (self.is_swatches()) {
                            color_option_slug = $('.prodigy-product__swatch-js[data-attribute="color"]:checked').data('slug');
                        }
                        if (variants.length > 1 || prodigyProductBulk.is_bulk()) {
                            for (let index in variants) {
                                if (typeof variants[index]['logo_options_ids'] === "undefined") {
                                    variants[index]['logo_options_ids'] = [];
                                }
                                for (let i in product_options[self.logo_attribute][color_option_slug]['logos']) {
                                    if (
                                        parseInt(product_options[self.logo_attribute][color_option_slug]['logos'][i]['location_id']) === parseInt(location_id) &&
                                        parseInt(product_options[self.logo_attribute][color_option_slug]['logos'][i]['logo_id']) === parseInt(logo_id)
                                    ) {
                                        variants[index]['logo_options_ids'].push(parseInt(i));
                                    }
                                }
                            }
                        }
                    }
                });
            }

            return variants;
        },

        is_swatches: function () {
            return $(this.prodigy_product_swatch_block_element).length !== 0;
        },

        filter_actual_options: function (current_options, variants) {
            let variant_options = [];
            let filtered_options = [];

            if (variants.length > 0) {
                for (let index in variants) {
                    for (let index_option in variants[index].attributes.options) {
                        if (variants[index].attributes.options[index_option].property_slug === this.logo_attribute) {
                            variant_options.push(variants[index].attributes.options[index_option].option_slug);
                        }
                    }
                }

                for (let key in current_options) {
                    if (variant_options.includes(current_options[key].name)) {
                        filtered_options.push(current_options[key]);
                    }
                }
            }

            return filtered_options;
        },


        set_logo_options_for_variant: function (variants, i, logo_option) {
            for (let index in variants) {
                if (typeof variants[index]['logo_options_ids'] === "undefined") {
                    variants[index]['logo_options_ids'] = [];
                }
                for (let index_option in variants[index].attributes.options) {
                    if (variants[index].attributes.options[index_option].property_slug === this.logo_attribute &&
                        variants[index].attributes.options[index_option].option_slug === logo_option
                    ) {
                        variants[index]['logo_options_ids'].push(i);
                    }
                }
            }

            return variants;
        },

        get_logo_options_single_variant: function () {
            let self = this;
            const images_logos_settings = self.get_images_logos_settings();
            let logo_options_ids = [];
            $('.prodigy-logo-tool__container.opened').each(function () {
                const $logo_select = $(this).find('.prodigy-logo-values-js');
                const $location_select = $(this).find('.prodigy-logo-location-js');
                const logo_id = self.is_logo_swatches() ? $(this).find('.prodigy-product__logo-swatch-js:checked').val() : $logo_select.val();
                const location_id = $location_select.val();

                for (let i in images_logos_settings) {
                    if (
                        parseInt(images_logos_settings[i].logo_id) === parseInt(logo_id) &&
                        parseInt(images_logos_settings[i].location_id) === parseInt(location_id)
                    ) {
                        logo_options_ids.push(i);
                        break;
                    }
                }
            });

            return logo_options_ids;
        },


        get_selected_locations_list: function ($excluded_location_select) {
            let location_ids = [];
            $('.prodigy-logo-tool__container.opened .prodigy-logo-location-js').not($excluded_location_select).each(function () {
                location_ids.push(parseInt($(this).val()));
            });

            return location_ids;
        },

        create_logo_element: function (logo_settings) {
            let $logo = $(document.createElementNS('http://www.w3.org/2000/svg', 'image'));
            $logo.addClass('prodigy-product__gallery-logo-js');
            $logo.attr('data-logo-id', logo_settings.logo_id);
            $logo.attr('data-location-id', logo_settings.location_id);
            $logo.attr('href', logo_settings.logo['original-url']);
            $logo.attr('width', logo_settings.location['width']);
            $logo.attr('height', logo_settings.location['height']);
            $logo.attr('x', logo_settings.location['x']);
            $logo.attr('y', logo_settings.location['y']);

            let transformX = logo_settings.location['x'] + (logo_settings.location['width'] / 2);
            let transformY = logo_settings.location['y'] + (logo_settings.location['height'] / 2);
            let logo_style = "transform-origin:" + transformX + "px " + transformY + "px; transform: rotate(" + logo_settings.location['angle'] + "deg) rotateY(" + logo_settings.location['rotation-y'] + "deg) rotateX(" + logo_settings.location['rotation-x'] + "deg)";
            $logo.attr('style', logo_style);

            return $logo;
        },

        get_max_add_logo_forms: function () {
            let self = this;
            const images_logos_settings = self.get_images_logos_settings();

            let logo_images = new Set();
            for (let i in images_logos_settings) {
                logo_images.add(images_logos_settings[i].location_id);
            }

            return logo_images.size > self.max_logo_quantity ? self.max_logo_quantity : logo_images.size;
        },

        show_logo_form: function () {
            let self = this;
            $(document).on("click", self.toggle_checkbox_selector, function () {
                let $container = $(this).closest('.container-js');
                let $location_select = $container.find('.prodigy-logo-location-js');

                if ($(this).is(':checked')) {
                    $container.removeClass('closed');
                    $container.addClass('opened');
                    if ($(document).find('.prodigy-logo-location-js').length < self.get_max_add_logo_forms()) {
                        let $clone = $(self.template_selector).contents().clone();
                        $(this).closest(self.main_logo_management_container).append($clone);
                        self.set_custom_logo_select();
                    }
                    self.preselect_logo_location($container, self.get_images_logos_settings(), $container.find('.prodigy-logo-value-js').val());
                    self.disable_selected_location($location_select.val());
                } else {
                    self.enable_selected_location($location_select.val());
                    if ($container.is('.container-js:last-of-type')) {
                        $container.removeClass('opened')
                        $container.addClass('closed');
                    } else {
                        $container.remove();
                    }
                }

                self.set_logos();
                if (self.is_logo_swatches()) {
                    self.set_logos_swatches();
                }
                self.get_logos_price();
                self.update_locations_availability();
                prodigyProduct.set_variants_data(self.get_variant_data());

                if (prodigyProductBulk.is_active_logo_bulk) {
                    $(document).trigger('enable-multiple-quantity');
                }
            });
        },

        bulk_logo_validate: function (attribute, current_options) {
            let product_options = JSON.parse($('#product-options-data-js').val());
            let logos = [];

            $('.prodigy-logo-tool__container.opened').each(function () {
                let current_location_id = $(this).find('.prodigy-logo-location-js').find('option:selected').val();
                for (let index in current_options) {
                    for (const key in product_options[attribute]) {
                        if (current_options[index].name !== key || typeof product_options[attribute][key]['logos'] === "undefined") {
                            continue;
                        }
                        for (const i in product_options[attribute][key]['logos']) {
                            if (
                                parseInt(product_options[attribute][key]['logos'][i]['option_id']) === parseInt(current_options[index].id) &&
                                parseInt(product_options[attribute][key]['logos'][i]['location_id']) === parseInt(current_location_id)
                            ) {
                                logos.push(product_options[attribute][key]['logos'][i]['logo_id']);
                            }
                        }
                    }
                }
            });

            logos = [...new Set(logos)];
            this.bulk_logo_disable(logos);
            this.set_logo_bulk(attribute, current_options);
        },


        set_logo_bulk: function (attribute, current_options) {
            let $container = $('.prodigy-logo-tool__container.opened');
            let current_location_id = $container.find('.prodigy-logo-location-js').find('option:selected').val();
            let product_options = JSON.parse($('#product-options-data-js').val());
            let current_logo_id = this.is_logo_swatches() ? $container.find('.prodigy-product__logo-swatch-js:checked').val() : $container.find('.prodigy-logo-values-js').find('option:selected').val();

            for (let index in current_options) {
                for (const key in product_options[attribute]) {
                    if (current_options[index].name !== key || typeof product_options[attribute][key]['logos'] === "undefined") {
                        continue;
                    }
                    for (const i in product_options[attribute][key]['logos']) {
                        if (
                            parseInt(product_options[attribute][key]['logos'][i]['option_id']) === parseInt(current_options[index].id) &&
                            parseInt(product_options[attribute][key]['logos'][i]['location_id']) === parseInt(current_location_id)
                        ) {
                            // set logo
                            let image_id = product_options[attribute][key]['logos'][i]['image_id'];
                            let $current_image = $('.main-gallery-image-js[data-image-id="' + image_id + '"]');
                            let $current_thumb = $('.thumb-gallery-image-js[data-image-id="' + image_id + '"]');
                            if (
                                parseInt(product_options[attribute][key]['logos'][i]['logo_id']) === parseInt(current_logo_id) &&
                                parseInt(product_options[attribute][key]['logos'][i]['location_id']) === parseInt(current_location_id)
                            ) {
                                $current_image.parent('svg').append(this.create_logo_element(product_options[attribute][key]['logos'][i]));
                                $current_thumb.closest('svg').append(this.create_logo_element(product_options[attribute][key]['logos'][i]));
                            }
                        }
                    }
                }
            }
        },

        bulk_logo_disable: function (logos) {
            let $container = $('.prodigy-logo-tool__container.opened');
            if (this.is_logo_swatches()) {
                let current_logo = $container.find('.prodigy-product__logo-swatch-js:checked').val();
                if (!logos.includes(parseInt(current_logo))) {
                    $container.find('.prodigy-product__logo-swatch-js:checked').removeProp('checked');
                }
                $container.find('.prodigy-product__logo-swatch-js').each(function () {
                    if (logos.includes(parseInt($(this).val()))) {
                        $(this).prop('disabled', false);
                        $(this).closest('.prodigy-tooltip-js').removeClass('prodigy-logo__disabled');
                        $(this).closest('.prodigy-radio__swatch-logo-btn').find('.prodigy-product__swatch-init-js').removeClass('prodigy-logo__disabled-mobile');
                    } else {
                        $(this).prop('disabled', true);
                        $(this).closest('.prodigy-tooltip-js').addClass('prodigy-logo__disabled');
                        $(this).closest('.prodigy-radio__swatch-logo-btn').find('.prodigy-product__swatch-init-js').addClass('prodigy-logo__disabled-mobile');
                    }
                });

                if (!logos.includes(parseInt(current_logo))) {
                    $container.find('.prodigy-product__logo-swatch-js:not(:disabled)').first().prop('checked', 'checked');
                }

                $('.prodigy-logo-tool__container.opened').each(function () {
                    const $logo_radio = $(this).find('.prodigy-product__logo-swatch-js:checked');
                    const default_logo_name = $logo_radio.data('name');
                    $(this).closest('.prodigy-logo-tool__container').find('.swatch-logo-name-js').text(default_logo_name);
                });

            } else {
                $container.find('.prodigy-logo-values-js option').each(function () {
                    $(this).prop('disabled', !logos.includes(parseInt($(this).val())));
                });

                if ($container.find('.prodigy-logo-values-js option:selected:disabled').length > 0) {
                    const val = $container.find('.prodigy-logo-values-js option:not(:disabled)').first().val();
                    this.set_logo_select_value($container.find('.prodigy-logo-values-js'), val);
                }
            }
        },

        set_bulk_logo_option_validate: function (attribute, current_options) {
            let self = this;
            let image_options = {};
            let product_options = JSON.parse($('#product-options-data-js').val());
            $('.prodigy-logo-tool__container.opened').each(function () {
                let $container = $(this);
                let location_id = $container.find('.prodigy-logo-location-js').find('option:selected').val();
                let current_logo_id = self.is_logo_swatches() ? $container.find('.prodigy-product__logo-swatch-js:checked').val() : $container.find('.prodigy-logo-values-js').val();

                for (let index in current_options) {
                    for (const key in product_options[attribute]) {
                        if (current_options[index].name !== key || typeof product_options[attribute][key]['logos'] === "undefined") {
                            continue;
                        }
                        for (const i in product_options[attribute][key]['logos']) {
                            if (
                                parseInt(product_options[attribute][key]['logos'][i]['option_id']) === parseInt(current_options[index].id) &&
                                parseInt(product_options[attribute][key]['logos'][i]['location_id']) === parseInt(location_id) &&
                                parseInt(product_options[attribute][key]['logos'][i]['logo_id']) === parseInt(current_logo_id)
                            ) {
                                current_options[index].has_logo = current_options[index].has_logo || true;
                                image_options[index] = current_options[index];
                            } else {
                                current_options[index].has_logo = current_options[index].has_logo || false;
                            }
                        }

                    }
                }
            });

            prodigyProduct.set_gallery(image_options, attribute);
            this.bulk_options_disable(current_options);
        },

        bulk_options_disable: function (current_options) {
            for (let index in current_options) {
                let bulk_input = $(".prodigy-bulk-input-js[data-option=" + current_options[index].name + "]");
                if (current_options[index].has_logo) {
                    bulk_input.attr('disabled', false);
                    bulk_input.closest('.prodigy-bulk__table-cell-body').removeClass('prodigy-bulk__table-cell-body--disabled');
                } else {
                    bulk_input.val('');
                    bulk_input.attr('disabled', true);
                    bulk_input.closest('.prodigy-bulk__table-cell-body').addClass('prodigy-bulk__table-cell-body--disabled');
                }
            }
        },

        bulk_locations_validate: function () {
            $('.prodigy-logo-tool__container.opened').each(function () {
                let $container = $(this);
                let $location_select = $container.find('.prodigy-logo-location-js');
                $location_select.find('option').attr('disabled', false);
            });
        },
    }

    $(document).ready(function () {
        product_logo_management.init();
    });
    window.product_logo_management_object = product_logo_management;

})(jQuery, window);
